import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconLockOpen = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Locked'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon ref={ref} viewBox='0 0 14 15' size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path d='M13.8333 -0.666687H13.1667V-2.03252e-05H13.8333V-0.666687ZM0.392 14.2753C0.652889 14.5362 0.966667 14.6666 1.33333 14.6666H9.33333C9.7 14.6666 10.014 14.5362 10.2753 14.2753C10.5362 14.014 10.6667 13.7 10.6667 13.3333V6.66665C10.6667 6.29998 10.5362 5.98598 10.2753 5.72465C10.014 5.46376 9.7 5.33331 9.33333 5.33331H8.66667V3.99998C8.66667 3.07776 8.34178 2.29154 7.692 1.64131C7.04178 0.991535 6.25556 0.666646 5.33333 0.666646C4.53333 0.666646 3.83333 0.913757 3.23333 1.40798C2.63333 1.90265 2.25 2.5222 2.08333 3.26665C2.03889 3.45553 2.08333 3.62487 2.21667 3.77465C2.35 3.92487 2.52778 3.99998 2.75 3.99998C2.90556 3.99998 3.04178 3.94709 3.15867 3.84131C3.27511 3.73598 3.36111 3.59998 3.41667 3.43331C3.53889 3.0222 3.77511 2.68042 4.12533 2.40798C4.47511 2.13598 4.87778 1.99998 5.33333 1.99998C5.88889 1.99998 6.36111 2.19442 6.75 2.58331C7.13889 2.9722 7.33333 3.44442 7.33333 3.99998V5.33331H1.33333C0.966667 5.33331 0.652889 5.46376 0.392 5.72465C0.130667 5.98598 0 6.29998 0 6.66665V13.3333C0 13.7 0.130667 14.014 0.392 14.2753ZM9.33333 6.66665V13.3333H1.33333V6.66665H9.33333ZM6.27533 10.942C6.014 11.2029 5.7 11.3333 5.33333 11.3333C4.96667 11.3333 4.65289 11.2029 4.392 10.942C4.13067 10.6806 4 10.3666 4 9.99998C4 9.63331 4.13067 9.31931 4.392 9.05798C4.65289 8.79709 4.96667 8.66665 5.33333 8.66665C5.7 8.66665 6.014 8.79709 6.27533 9.05798C6.53622 9.31931 6.66667 9.63331 6.66667 9.99998C6.66667 10.3666 6.53622 10.6806 6.27533 10.942Z' />
    </Icon>
  )
}

IconLockOpen.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconLockOpen
